import { render } from "./ChatUnit.vue?vue&type=template&id=05d96530&scoped=true&ts=true"
import script from "./ChatUnit.vue?vue&type=script&lang=ts"
export * from "./ChatUnit.vue?vue&type=script&lang=ts"

import "./ChatUnit.vue?vue&type=style&index=0&id=05d96530&lang=less&scoped=true"

import exportComponent from "/Users/rppig42/Code/dbkf/uworker-mobile/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.2.21_vue@3.2.21_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05d96530"]])

export default __exports__